<div class="wrappers" [ngClass]="{ 'delete-padding': requireWorkspaceSync }" >

  <!-- Workspace Sync Notification -->
  @if (requireWorkspaceSync === true) {
    <div class="workspace-sync-notification-wrapper">
      <particle-platform-tool-message-bar
        [handler]="null"
        [messageBar]="workspaceSyncMessageBar"
        (commandFinished)="onWorkspaceSyncCommandFinished($event)">
      </particle-platform-tool-message-bar>
    </div>
  }

  <img src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/logos/logo-title.png" alt="Orbitax Logo">

  <div class="dashboard">
    <div class="card" *ngFor="let card of cards">
      <div class="card__header">
      <span class="card__icon">
        <i *ngIf="card.icon && !card.isEmoji" [ngClass]="card.icon"></i>
        <span *ngIf="card.isEmoji">{{ card.icon }}</span>
      </span>
        <h3 class="card__title">{{ card.title }}</h3>
      </div>
      <ul class="card__list">
        <li *ngFor="let link of card.links" [class.card__list-item--expandable]="link.hasChildren">
          <!-- Link with potential children -->
          <div class="card__list-item">
            <a
                    *ngIf="!link.hasChildren"
                    (click)="navigateToLink(link.url)"
                    class="card__list-link">
              {{ link.label }}
            </a>

            <!-- Expandable link -->
            <div
                    *ngIf="link.hasChildren"
                    (click)="toggleLinkExpansion(link.id)"
                    class="card__list-expandable">
            <span class="card__list-toggle">
              <i class="fa-solid" [ngClass]="isLinkExpanded(link.id) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
            </span>
              <span class="card__list-label">{{ link.label }}</span>
            </div>
          </div>

          <!-- Children items -->
          <ul class="card__list-children" *ngIf="link.hasChildren && isLinkExpanded(link.id)">
            <li *ngFor="let child of link.children">
              <a (click)="navigateToLink(child.url)" class="card__list-child-link">{{ child.label }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
